import React from 'react';
import { Mail, Phone, MapPin, ArrowUpRight } from 'lucide-react';
import { BOOKING_URL, CTA_LABEL } from '../data/constants';

const nav = [
  { href: '#intro', label: 'Was ist HIREKA' },
  { href: '#prozess', label: 'Ablauf' },
  { href: '#premium-plus', label: 'Preis' },
  { href: '#credits', label: 'Credit-System' },
  { href: '#about', label: 'Über uns' },
  { href: '#testimonials', label: 'Erfahrungen' },
  { href: '#faq', label: 'FAQ' },
  { href: '/jobs', label: 'Jobs' },
];

const Footer = () => (
  <footer className="relative bg-obsidian text-slate-400 border-t border-white/5" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-5 lg:px-8 pt-20 pb-10">
      <div className="grid md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <img src="/hireka-logo.png" alt="HIREKA" className="h-9 brightness-0 invert" />
          <p className="mt-6 leading-relaxed max-w-sm">
            Die Recruiting-Agentur aus Hamburg. Gebriefte Kandidaten in 24 Stunden – zum Festpreis, mit kostenloser Nachbesetzung.
          </p>
          <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" className="btn-lux mt-8 px-6 py-3 text-sm" data-testid="footer-cta">
            {CTA_LABEL} <ArrowUpRight className="w-4 h-4" />
          </a>
        </div>

        <div className="md:col-span-3">
          <h3 className="text-white font-semibold text-xs uppercase tracking-[0.2em] mb-6">Navigation</h3>
          <ul className="space-y-3 text-sm">
            {nav.map((n) => (
              <li key={n.href}><a href={n.href} className="hover:text-amber-300 transition-colors">{n.label}</a></li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <h3 className="text-white font-semibold text-xs uppercase tracking-[0.2em] mb-6">Kontakt</h3>
          <ul className="space-y-4 text-sm">
            <li className="flex items-start gap-3"><MapPin className="w-4 h-4 text-amber-400 mt-0.5" /><span>HIREKA (Sven Köhler)<br />Walddörferstr. 104<br />22041 Hamburg</span></li>
            <li className="flex items-center gap-3"><Phone className="w-4 h-4 text-amber-400" /><a href="tel:+4915167026918" className="hover:text-amber-300 transition-colors">+49 151 670 269 18</a></li>
            <li className="flex items-center gap-3"><Mail className="w-4 h-4 text-amber-400" /><a href="mailto:info@hireka.io" className="hover:text-amber-300 transition-colors">info@hireka.io</a></li>
          </ul>
        </div>
      </div>

      <div className="mt-16 pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-slate-500">
        <p>© {new Date().getFullYear()} HIREKA. Alle Rechte vorbehalten.</p>
        <div className="flex items-center gap-6">
          <a href="/impressum.html" className="hover:text-amber-300 transition-colors" data-testid="footer-impressum">Impressum</a>
          <a href="/impressum.html" className="hover:text-amber-300 transition-colors">Datenschutz</a>
          <a href="https://app.emergent.sh/?utm_source=emergent-badge" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-amber-300 transition-colors">
            <img src="https://avatars.githubusercontent.com/in/1201222?s=120&u=2686cf91179bbafbc7a71bfbc43004cf9ae1acea&v=4" alt="Made with Emergent" className="w-4 h-4 rounded" />
            Made with Emergent
          </a>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
